import styled from 'styled-components';

export const AddConsumptionWrapper = styled.div`
    .input-select {
        width: 160px;
    }
`;

export const ConsumptionWrapper = styled.div`
    padding-left: 10px;
`;

export const FuelTypeHeaderStyle = styled.div`
    font-size: 0.8rem;
    font-weight: 500;
    color: #00447e;
    margin: 0 0 0.5rem;
`;

export const CostWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;
